module.exports = fox._r("images/logos/pbpLogo_transparentBg.png", __webpack_public_path__ + "_/_/_/common/frame/images/logos/pbpLogo_transparentBg.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/images/logos/pbpLogo_transparentBg.png
// module id = 323
// module chunks = 2